<template>
  <!-- 如何获得 -->
  <div class="container">
    <!-- 顶部导航栏 -->
    <HeadTab :typeindex="1"></HeadTab>
    <img class="opl" src="/static/img/Mask_group.png" alt="" />
    <div class="obtain">
      <div class="obtain_inner">
        <div class="obtain_left">
          <div class="obtain_title">Как взять микрокредит?</div>
          <div class="step_list" v-for="item in stepList" :key="item.step">
            <div class="step_card">
              <img class="step_icon" :src="item.icon" :alt="item.title" />
              <div class="step_content">
                <div class="opw">
                  <div class="step_tag">ШАГ {{ item.step }}</div>
                  <div class="oid"></div>
                </div>
                <div class="step_title">{{ item.title }}</div>
                <div class="step_text">{{ item.text }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="obtain_right">
          <LoanCard></LoanCard>
          <div class="require_panel">
            <div class="require_title">МИНИМАЛЬНЫЕ ТРЕБОВАНИЯ</div>
            <div class="require_item" v-for="item in requireList" :key="item">
              <img class="require_icon" src="/static/img/Container.png" alt="check" />
              <div class="require_text">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <BomTab :jumpindex="0"></BomTab>
  </div>
</template>

<script>
  import HeadTab from '@/components/HeadTab.vue'
  import BomTab from '@/components/BomTab.vue'
  import LoanCard from '@/components/loancard.vue'
  export default {
    name: "obtain",
    data() {
      return {
        stepList: [
          {
            step: 1,
            icon: '/static/img/Overlay_1.png',
            title: 'Заполните анкету',
            text: 'Укажите основные данные о себе. Это займет не более 5 минут благодаря оптимизированным полям ввода данных.'
          },
          {
            step: 2,
            icon: '/static/img/Overlay_2.png',
            title: 'Выберите сумму',
            text: 'Выберите необходимую сумму и срок микрокредита, подтвердите свою личность через безопасную систему верификации.'
          },
          {
            step: 3,
            icon: '/static/img/Overlay_3.png',
            title: 'Получите деньги',
            text: 'После одобрения деньги будут мгновенно переведены на вашу банковскую карту или счет. Среднее время ожидания - до 5 минут.'
          }
        ],
        requireList: [
          'Возраст от 18 до 65 лет',
          'Действительное удостоверение личности РК',
          'Наличие активного номера мобильного телефона, зарегистрированного на ваше имя.'
        ]
      };
    },
    components: {
      BomTab,
      HeadTab,
      LoanCard
    },
    mounted () {
    },
    methods: {},
  };
</script>

<style scoped>
  .opl{
    width: 3.29rem;
    height: 1.82rem;
    position: absolute;
    top: 0.57rem;
    left: 0;
  }
  .obtain {
    background: rgba(244, 247, 250, 1);
    padding: 0.78rem 1.58rem;
  }
  .obtain_inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.58rem;
  }
  .obtain_title {
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.21rem;
    margin-bottom: 0.17rem;
  }
  .step_list {
    width: 3.48rem;
    display: flex;
    flex-direction: column;
    gap: 0.14rem;
    border-radius: 0.04rem;
    background: #ffffff;
    margin-bottom: 0.08rem;
  }
  .step_card {
    display: flex;
    align-items: flex-start;
    border-radius: 0.04rem;
    background: rgba(255, 255, 255, 1);
    padding: 0.1rem 0.1rem 0.16rem;
  }
  .step_icon {
    width: 0.25rem;
    height: 0.25rem;
    margin-right: 0.1rem;
  }
  .step_content {
    flex: 1;
  }
  .opw{
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
  }
  .step_tag {
    color: rgba(0, 102, 204, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.06rem;
    margin-bottom: 0.03rem;
  }
  .oid{
    width: 2.68rem;
    height: 0.01rem;
    background: rgba(223, 225, 230, 0.5);
    margin-left: 0.04rem;
  }
  .step_title {
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.09rem;
    margin-bottom: 0.02rem;
  }
  .step_text {
    color: rgba(102, 102, 102, 1);
    font-family: Montserrat;
    font-weight: 400;
    font-size: 0.07rem;
    line-height: 0.08rem;
  }
  .obtain_right {
    width: 3.74rem;
    display: flex;
    flex-direction: column;
    gap: 0.14rem;
  }
  .loan_panel,
  .require_panel {
    background: rgba(255, 255, 255, 0.98);
    border-radius: 0.14rem;
    box-shadow: 0rem 0.08rem 0.2rem rgba(15, 23, 42, 0.08);
  }
  .loan_panel {
    padding: 0.14rem;
  }
  .loan_label {
    color: #475569;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.1rem;
    margin-bottom: 0.14rem;
  }
  .loan_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.14rem;
  }
  .loan_control {
    width: 0.32rem;
    height: 0.32rem;
    border-radius: 50%;
    background: #2f76d2;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 0.22rem;
  }
  .loan_control-active {
    background: #2f76d2;
  }
  .loan_value {
    color: #2372d9;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.24rem;
  }
  .loan_total {
    background: #f3f6fb;
    border-radius: 0.1rem;
    padding: 0.11rem 0.12rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #8b8b8b;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.09rem;
    margin-bottom: 0.14rem;
  }
  .loan_total span:last-child {
    color: #333333;
    font-weight: 700;
  }
  .loan_btn {
    height: 0.44rem;
    border-radius: 0.09rem;
    background: #2f76d2;
    color: #ffffff;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.14rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0rem 0.04rem 0.08rem rgba(47, 118, 210, 0.26);
    margin-bottom: 0.08rem;
  }
  .loan_note {
    color: #b0b7c3;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.07rem;
  }
  .require_panel {
    padding: 0.13rem;
    border-radius: 0.08rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0rem 0.02rem 0.05rem rgba(0, 0, 0, 0.06);
  }
  .require_title {
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.06rem;
    margin-bottom: 0.08rem;
  }
  .require_item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.06rem;
  }
  .require_icon {
    width: 0.06rem;
    height: 0.06rem;
    margin-right: 0.06rem;
    flex-shrink: 0;
  }
  .require_text {
    color: rgba(102, 102, 102, 1);
    font-family: Montserrat;
    font-weight: 400;
    font-size: 0.07rem;
  }

  @media screen and (max-width: 1200px) {
    .obtain {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }
    .obtain_inner {
      gap: 0.24rem;
    }
    .obtain_left,
    .obtain_right {
      width: 50%;
    }
  }

  @media screen and (max-width: 768px) {
    .opl{
      width: 2.29rem;
      height: 1.32rem;
      position: absolute;
      top: 0.95rem;
      left: 0;
    }
    .obtain {
      padding-top: 0.42rem;
      padding-bottom: 0.48rem;
    }
    .obtain_inner {
      flex-direction: column;
    }
    .obtain_left,
    .obtain_right {
      width: 100%;
    }
    .obtain_title {
      font-size: 0.24rem;
      line-height: 0.3rem;
    }
    .step_title {
      font-size: 0.15rem;
    }
    .loan_value {
      font-size: 0.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/obtain.vue